var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/MediaComponents/index.tsx",
  _this = this;
import React from 'react';
import Media from 'react-media';
var breakPoints = {
  md: 768,
  lg: 1200
};
var MOBILE_SCREEN = "(max-width: ".concat(breakPoints.md - 1, "px)");
var TABLET_SCREEN = "(min-width: ".concat(breakPoints.md, "px)");
var MOBILE_TABLET_SCREEN = "(max-width: ".concat(breakPoints.lg - 1, "px)");
var DESKTOP_SCREEN = "(min-width: ".concat(breakPoints.lg, "px)");
export var MobileScreen = function MobileScreen(_ref) {
  var children = _ref.children,
    defaultMatches = _ref.defaultMatches;
  return /*#__PURE__*/React.createElement(Media, {
    defaultMatches: defaultMatches,
    query: MOBILE_SCREEN,
    render: function render() {
      return children;
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 3
    }
  });
};
export var TabletScreen = function TabletScreen(_ref2) {
  var children = _ref2.children,
    defaultMatches = _ref2.defaultMatches;
  return /*#__PURE__*/React.createElement(Media, {
    defaultMatches: defaultMatches,
    query: TABLET_SCREEN,
    render: function render() {
      return children;
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 3
    }
  });
};
export var MobileTabletScreen = function MobileTabletScreen(_ref3) {
  var children = _ref3.children,
    defaultMatches = _ref3.defaultMatches;
  return /*#__PURE__*/React.createElement(Media, {
    defaultMatches: defaultMatches,
    query: MOBILE_TABLET_SCREEN,
    render: function render() {
      return children;
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 3
    }
  });
};
export var DesktopScreen = function DesktopScreen(_ref4) {
  var children = _ref4.children,
    defaultMatches = _ref4.defaultMatches;
  return /*#__PURE__*/React.createElement(Media, {
    defaultMatches: defaultMatches,
    query: DESKTOP_SCREEN,
    render: function render() {
      return children;
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 3
    }
  });
};
//# sourceMappingURL=index.js.map